// "🌙 Dark Mode" : "☀️ Light Mode"
import { useDispatch, useSelector } from "react-redux";
import { toggleTheme } from "../../../app/store/slices/themeSlice";
import "./theme-switcher.css";

export default function ThemeSwitcher() {
  const dispatch = useDispatch();
  const theme = useSelector((state) => state.theme.current);

  return (
    <div className="t-s-container">
      <span className="theme-switch">
        <input
          type="checkbox"
          id="switcher"
          onChange={() => dispatch(toggleTheme())}
          defaultChecked={theme === "light" ? true : false}
        />
        <label htmlFor="switcher"></label>
      </span>
    </div>
  );
}
